// DEPENDS 
import React, {useState, useRef} from 'react';
import { Link } from 'react-router-dom';
// data 
import {ring} from '../../../assets/data/guides.js'

// COMPS
import TOBMarketing from '../TOBMarketing.js';


// CSS 
import "../../../CSS/TOB/Docs/Ring.css"


const Ring = () => {
    // used to set which step in the guide that will be shown, default to the first one on the list.
    const idx = useRef(0)
    const [guide, setGuide] = useState(ring[idx.current]);
    const idx_capt = useRef(0)

    // for moving steps in teh workflow
    const handleGuide = () => {
            idx.current += 1
            console.log(idx)
            setGuide(ring[idx.current])
            window.scrollTo({
                top: 120,
                behavior: "smooth"
            })
    }

    const handleBack = () => {
        if (idx.current > 0) {
            idx.current -= 1
            console.log(idx)
            setGuide(ring[idx.current])
            window.scrollTo({
                top: 120,
                behavior: "smooth"
            })
        } else {
            window.alert("page error, please reload.")
            return null
        }
    }


    return(
        <div className='Ring'>
            <div className='Ring__return' id="button_wop1Home" style={{display: idx.current === 3 ? "flex" : "none"}}>
                <Link to="/TOBHomes" className='return__link'>Return to the Home Page</Link>
            </div>
            <div className='Ring__guide' style={{display: idx.current === 3 ? "none" : "flex"}}>
                <div className='guide__viewContainer' id={`viewer_rng_${idx.current}`}>
                    
                </div>
                <div className='guide__captions'>
                    <h1 className='captions__title'>{guide.title}</h1>
                    {guide.captions.map((item) => {
                        idx_capt.current += 1
                        return(
                            <p 
                                className='captions__copy' 
                                id={`copy_rng_${idx_capt.current}`} 
                                key={`copy_rng_${idx_capt.current}`}
                            >{item}</p>
                        )
                    })}
                </div>
                <div className='guide__c4sale' style={{display: idx.current === 2 ? "flex" : "none"}}>
                    <TOBMarketing />
                </div>
                <div className='guide__buttoncontainer' id='ring_bullshit'>
                    <button className='buttonContainer__button' id='button_ringback' onClick={handleBack} style={{opacity: idx.current > 0 ? "70%" : "0%"}}>Back</button>
                    <button className='buttonContainer__button' id='button_ringnext' onClick={handleGuide}>Next</button>
                </div>
            </div>
        </div>
    );
};

export default Ring;